const casbin = require('casbin')
import API from '@/services/api'

const Auth = {
  //- The enforcer
  enforcer: null,

  //- Initial model
  modelDef: '',

  //- Initial policy
  policyDef: '',

  //- Auth init method
  async init() {
    // eslint-disable-next-line no-console
    console.info('Auth - init')

    //- Load policies and model from db
    await API.getAuth()
      .then(async res => {

        this.modelDef = res.data.model_definition
        this.policyDef = res.data.policy_definition.map(o => {return `p, ${o[0]}, ${o[1]}, ${o[2]}`}).join("\n")

        // eslint-disable-next-line new-cap
        const model = new casbin.newModel(this.modelDef)

        //- TODO - grab from API
        const policyAdapter = new casbin.StringAdapter(this.policyDef)

        this.enforcer = await casbin.newEnforcer(model, policyAdapter)

        this.enforcer.setModel(model)
        this.enforcer.setAdapter(policyAdapter)
        this.enforcer.enableAutoSave(false)

        return this.enforcer
      })
  },

  //- ENFORCEMENT

  //- Test Enforcement of a rule: 'subject','object','action'
  enforce(subject, object, action) {
    return this.enforcer.enforce(subject, object, action)
  },

  // POLICIES

  //- Adds a policy to policies: 'subject','object','action'
  addPolicy(subject, object, action) {
    return this.enforcer.addPolicy(subject, object, action)
  },

  //- Lists all policies (synchronus)
  getPolicy() {
    return this.enforcer.getPolicy()
  },

  // ROLES

  //- Adds a role to user: 'subject','role'
  addRoleForUser(subject, role) {
    return this.enforcer.addRoleForUser(subject, role)
  },

  //- Lists users for a role: 'role'
  getUsersForRole(role) {
    return this.enforcer.getUsersForRole(role)
  },

  //- Deletes a role: 'role'
  deleteRole(role) {
    return this.enforcer.deleteRole(role)
  },

  //- Lists all roles
  getAllRoles() {
    return this.enforcer.getAllRoles()
  },

  // lits all named roles: 'g'
  getAllNamedRoles(role) {
    return this.enforcer.getAllNamedRoles(role)
  },

  // USERS

  //- Lists roles for user: 'subject'
  getRolesForUser(subject) {
    return this.enforcer.getRolesForUser(subject)
  },

  //- Test if a user belongs to a role: 'subject', 'role'
  hasRoleForUser(subject, role) {
    return this.enforcer.hasRoleForUser(subject, role)
  },

  //- Removes a role from a user: 'subject', 'role'
  deleteRoleForUser(subject, role) {
    return this.enforcer.deleteRoleForUser(subject, role)
  },

  //- Removes all roles from a user: 'subject'
  deleteRolesForUser(subject) {
    return this.enforcer.deleteRolesForUser(subject)
  },

  //- Removes a user: 'subject'
  deleteUser(subject) {
    return this.enforcer.deleteUser(subject)
  },

  //- Gets permissions for a user: 'subject'
  getPermissionsForUser(subject) {
    return this.enforcer.getPermissionsForUser(subject)
  },

  //- Gets implict permissions for a user: 'subject'
  getImplicitPermissionsForUser(subject) {
    return this.enforcer.getImplicitPermissionsForUser(subject)
  },

  // ACTIONS

  deletePermission(action) {
    return this.enforcer.deletePermission(action)
  },

  /*

  await e.addPermissionForUser('bob', 'read')
  await e.deletePermissionForUser("bob", "read")
  await e.deletePermissionsForUser('bob')
  e.getPermissionsForUser('bob')
  e.hasPermissionForUser('alice', 'read')

  const hasPolicy = e.hasPolicy('data2_admin', 'data2', 'read')

  const p = ['alice', 'data1', 'read']
  const removed = await e.removePolicy(...p)

  const has = e.hasGroupingPolicy('alice', 'data2_admin')

  const added = await e.addGroupingPolicy('group1', 'data2_admin')
  const removed = await e.removeGroupingPolicy('alice', 'data2_admin')
  */
}

export default Auth
